import "./BackgroundSelectionCard.css";
import React from "react";

export interface IBackgroundSelectionCardProps {
    title: string;
    description?: string;
    isSelected: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export default function BackgroundSelectionCard({
    title,
    description,
    isSelected,
    disabled = false,
    onClick,
}: IBackgroundSelectionCardProps): React.ReactElement {
    const cardClass = `bg-card${isSelected ? " bg-card--selected" : ""}${disabled ? " is-disabled" : ""}`;

    return (
        <button
            type="button"
            className={cardClass}
            disabled={disabled}
            onClick={disabled ? undefined : onClick}
        >
            <div className="bg-card__title">{title}</div>
            {description ? <div className="bg-card__desc">{description}</div> : null}
        </button>
    );
}
